/**
 * ItemCard
 * 
 * Displays a single inventory item with icon, name, and description
 */

import { memo } from 'react';
import { Item } from '../types';
import styles from './item-card.module.css';

export interface ItemCardProps {
  item: Item;
  onClick?: () => void;
}

export const ItemCard = memo(({ item, onClick }: ItemCardProps) => {
  return (
    <div 
      className={`${styles.itemCard} ${onClick ? styles.clickable : ''}`} 
      onClick={onClick}
      role={onClick ? "button" : "article"}
      tabIndex={onClick ? 0 : undefined}
      aria-label={`${item.name}: ${item.description}`}
    >
      <div className={styles.itemIcon} aria-hidden="true">
        {item.icon ? (
          <img src={item.icon} alt="" />
        ) : (
          <span>📦</span>
        )}
      </div>
      <div className={styles.itemName}>{item.name}</div>
      <div className={styles.itemDescription}>{item.description}</div>
    </div>
  );
});

